/**
 * Pure math for the mobile safety controls (SPEC §17.7): slide-to-confirm and press-and-hold.
 * Kept free of DOM so the thresholds are unit-tested; the React components only wire pointer
 * events to these functions.
 */

/** Fraction of the track the knob has travelled, clamped to [0, 1]. */
export function slideProgress(
  startX: number,
  currentX: number,
  trackWidth: number,
  knobWidth: number,
): number {
  const travel = Math.max(trackWidth - knobWidth, 1);
  return Math.min(Math.max((currentX - startX) / travel, 0), 1);
}

/** Default: the knob must reach 92% of the track before release confirms. */
export const SLIDE_CONFIRM_THRESHOLD = 0.92;

export function slideConfirmed(progress: number, threshold = SLIDE_CONFIRM_THRESHOLD): boolean {
  return progress >= threshold;
}

/** Press-and-hold (SPEC §17.7 order pad): 400 ms ⚙ with a progress ring. */
export const HOLD_TO_CONFIRM_MS = 400;

export function holdProgress(pressedAtMs: number, nowMs: number, holdMs = HOLD_TO_CONFIRM_MS): number {
  return Math.min(Math.max((nowMs - pressedAtMs) / holdMs, 0), 1);
}

export function holdConfirmed(
  pressedAtMs: number,
  releasedAtMs: number,
  holdMs = HOLD_TO_CONFIRM_MS,
): boolean {
  return releasedAtMs - pressedAtMs >= holdMs;
}
